/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Session_Idle_LogoutInputs */



/**
* | output |
* | --- |
* | "You were signed out for security because you were idle." |
*
* @param {Auth_Session_Idle_LogoutInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const auth_session_idle_logout = /** @type {((inputs?: Auth_Session_Idle_LogoutInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Session_Idle_LogoutInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Du wurdest aus Sicherheitsgründen abgemeldet, da du inaktiv warst.")
	return /** @type {LocalizedString} */ ("You were signed out for security because you were idle.")
});